import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Merge } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { api } from "../lib/api";

const Group = ({ g, i, onDone }) => {
  const [to, setTo] = useState(g[0].name);
  const [busy, setBusy] = useState(false);
  const merge = async () => {
    setBusy(true);
    try { const r = await api.mergeNationalities(g.map((x) => x.name), to); toast.success(`تم توحيد ${r.updated} موظف إلى «${to}»`); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر التوحيد"); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2 rounded-xl border border-amber-200 bg-amber-50/40 p-3" data-testid={`nat-group-${i}`}>
      <p className="text-xs text-slate-500">اختر الاسم الموحّد:</p>
      <div className="flex flex-wrap gap-2">
        {g.map((x) => (
          <label key={x.name} className={`flex cursor-pointer items-center gap-1.5 rounded-full border px-3 py-1 text-sm ${to === x.name ? "border-emerald-500 bg-emerald-50 text-emerald-800" : "border-slate-200 bg-white"}`} data-testid={`nat-opt-${i}-${x.name}`}>
            <input type="radio" className="hidden" checked={to === x.name} onChange={() => setTo(x.name)} /> {x.name} <span className="text-xs text-slate-400">({x.count})</span>
          </label>
        ))}
      </div>
      <Button size="sm" className="gap-1 bg-emerald-600 hover:bg-emerald-700" disabled={busy} onClick={merge} data-testid={`nat-merge-${i}`}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Merge className="h-4 w-4" />} توحيد</Button>
    </div>
  );
};

export const NationalityMergeDialog = ({ open, onOpenChange, onSaved }) => {
  const [d, setD] = useState(null);
  const load = () => api.nationalityGroups().then(setD).catch(() => setD({ groups: [] }));
  useEffect(() => { if (open) { setD(null); load(); } }, [open]);
  const dups = (d?.groups || []).filter((g) => g.length > 1);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent dir="rtl" className="w-[95vw] max-w-lg max-h-[85vh] overflow-y-auto" data-testid="nat-merge-dialog">
        <DialogHeader className="text-start"><DialogTitle>توحيد الجنسيات</DialogTitle>
          <DialogDescription className="text-start">كتابات متشابهة لنفس الجنسية (مثل باكستان / باكستاني). اختر الاسم الصحيح وسيُحدَّث في ملفات كل الموظفين.</DialogDescription></DialogHeader>
        {!d ? <Loader2 className="mx-auto h-5 w-5 animate-spin text-slate-400" /> : dups.length ? (
          <div className="space-y-3">{dups.map((g, i) => <Group key={g.map((x) => x.name).join("|")} g={g} i={i} onDone={() => { load(); onSaved?.(); }} />)}</div>
        ) : <p className="py-6 text-center text-sm text-emerald-700" data-testid="nat-merge-empty">كل الجنسيات موحّدة — لا توجد كتابات مكررة</p>}
      </DialogContent>
    </Dialog>
  );
};
